// eslint-disable-next-line no-empty-function
function noop() {}

export default noop;
